import { useRef } from "react";

import { Cropper } from "react-cropper";

import "react-cropper/node_modules/cropperjs/dist/cropper.css";

export default function PhotoCropModal({
  image,
  onClose,
  onConfirm,
  onChangeImage,
}) {
  const cropperRef = useRef(null);

  const handleConfirm = () => {
    const cropper =
      cropperRef.current?.cropper;

    if (!cropper) return;

    const canvas =
      cropper.getCroppedCanvas({
        width: 1200,
        height: 1200,
      });

    canvas.toBlob(
      (blob) => {
        if (!blob) return;

        const file = new File(
          [blob],
          image.name.replace(/\.\w+$/, ".jpg"),
          {
            type: "image/jpeg",
          }
        );

        onConfirm(file);
      },
      "image/jpeg",
      0.92
    );
  };

  return (
    <div className="crop-modal">
      <div className="crop-modal-content">

        <div className="crop-header">
          <h3>Reencuadra tu foto</h3>

          <button
            type="button"
            onClick={onClose}
          >
            x
          </button>
        </div>

        <Cropper
  src={image.preview}
  style={{
    width: "100%",
    height: 420,
  }}
  aspectRatio={1}
  guides={false}
  viewMode={1}
  dragMode="move"
  background={false}
  responsive={true}
  autoCropArea={0.8}
  cropBoxMovable={false}
  cropBoxResizable={false}
  movable={true}
  zoomable={true}
  scalable={false}
  rotatable={false}
  checkOrientation={false}
  ref={cropperRef}
/>

        <div className="crop-actions">
          {onChangeImage && (
            <button
              type="button"
              onClick={onChangeImage}
            >
              Elegir otra foto
            </button>
          )}

          <button
            type="button"
            onClick={onClose}
          >
            Cancelar
          </button>

          <button
            type="button"
            onClick={handleConfirm}
          >
            Aplicar recorte
          </button>
        </div>
      </div>
    </div>
  );
}